import Vuex from 'vuex';
import store from '../../store';
import exportApiClient from '@/services/apiServices/exportApiClient.js'
import referenceApiClient from '@/services/apiServices/referenceApiClient.js'

//defines the web prefix that uses this file
const InstanceName = 'web';

//Defines the plugin used to attach to events once in tool.
const WebPlugin = store => {
    store.subscribeAction(async (action, state) => {
        //if instance matched execute the actions
        if (state.instance && state.instance.toLowerCase() == InstanceName) {
            switch (action.type) {
                case 'refreshProfile':
                    //Pull the profile as defined by the tool
                    var refreshContent = {
                        targetProfiles: [
                            {
                                name: "placeholder",
                                project: {
                                    id: 1,
                                    name: "project"
                                },
                                library: {
                                    id: 2,
                                    name: "Library"
                                }
                            }
                        ],
                        downloadLocation: "C:/testlocationdemo/"
                    };
                    store.commit('GET_PROFILE', refreshContent);
                    //Change to 1 to test V1 functions
                    var versionContent = 2; // Set test version here
                    if (versionContent) {
                        store.commit('GET_VERSION', versionContent);
                    }
                    break;
                case 'selectPart':
                    break;
                case 'downloadComplete':
                    //when the download is available process passing the content to the tool
                    //download should only be valid if a profile was selected
                    //check non-null profile here
                    exportApiClient.Download(store.state.export.token).then((response) => {
                        //grab current target library from profile
                        if (response.data.success) {
                            let url = 'data:application/zip;base64,'.concat(response.data.fileContent);
                            let a = document.createElement('a');
                            a.href = url;
                            a.download = 'file.zip';
                            a.click();
                        } else {
                            //kick off general error notification
                            store.commit('SET_GLOBAL_ERROR', 'Download Failure');
                        }
                    });
                    break;
                case 'downloadReference':
                    referenceApiClient.Download(action.payload).then((response) => {
                        //grab current target library from profile
                        if (response.data.found) {
                            let url = 'data:application/zip;base64,'.concat(response.data.encodedZip);
                            let a = document.createElement('a');
                            a.href = url;
                            a.download = response.data.fileName + ".zip";
                            a.click();
                        } else {
                            //kick off general error notification
                            store.commit('SET_GLOBAL_ERROR', 'Download Reference Design Not Found');
                        }

                    }).catch(() => {
                        store.commit('SET_GLOBAL_ERROR', 'Download Reference Design Failure');
                    });
                    break;
                case 'openUrl':
                    //Open External Url
                    window.open(action.payload.url, '_blank');
                    break;
                case 'getActiveLibrary':
                    var activeProfile = { name: 'test library', project: { id: 1, name: 'projectname' }, library: { id: 2, name: 'libname' } };
                    var resultValid = true;
                    store.commit('SET_ACTIVE_LIBRARY', { profile: activeProfile, valid: resultValid });
                    //Test no active library here
                    //store.commit('SET_ACTIVE_LIBRARY', { profile: null, valid: false });
                    break;
                case 'getLibraryDropdown':
                    var libProfile = { name: 'test library', project: { id: 1, name: 'projectname' }, library: { id: 2, name: 'libname' } };
                    store.commit('SET_OPEN_LIBRARIES', openLibraries);
                    store.commit('SET_ACTIVE_LIBRARY', { profile: libProfile, valid: resultValid });
                    break;
            }
        }
    });
}

export { WebPlugin };